<template>
    <div class="dashboard-section">
        <div class="col-xs-12">
            <label>NOTIFICATIONS</label>
            <div class="raised low notifications dashboard-info">
                <i class="dashboard-icon fa fa-4x fa-bell"></i>
                <div id="notifications-toggle-acknowledged">
                    <div class="low" :class="{ 'raised': !showAcknowledged }" @click="toggleShowAcknowledged(false)">NEW</div>
                    <div class="low" :class="{ 'raised': showAcknowledged }" @click="toggleShowAcknowledged(true)">ALL</div>
                </div>
                <transition name="fade" mode="out-in">
                    <div class="empty-dashboard" key="loading" v-if="loading">
                        <i class="fa fa-spinner fa-spin fa-2x"></i>
                    </div>
                    <div class="empty-dashboard" key="no_new" v-else-if="notifications.length == 0 && !showAcknowledged">
                        No new notifications
                    </div>
                    <div class="empty-dashboard" key="none" v-else-if="notifications.length == 0">
                        No notifications
                    </div>
                    <div id="user-notifications-list" key="content" v-else>
                        <ul class="list-group">
                            <li v-for="notification in notifications" class="list-group-item fade" :class="{ in: removed.indexOf(notification.notification_id) == -1 }">
                                <div :notification_id="notification.notification_id">
                                    <i class="close fa fa-close" @click="removeNotification(notification.notification_id)" v-if="!notification.reviewed_ts"></i>
                                    <span class="label label-default">{{ notification.created_ts }}</span>
                                    <span class="label"
                                          :class="{
                                            'label-default': notification.notification_class == 'label-default',
                                            'label-primary': notification.notification_class == 'label-primary',
                                            'label-success': notification.notification_class == 'label-success',
                                            'label-info': notification.notification_class == 'label-info',
                                            'label-warning': notification.notification_class == 'label-warning',
                                            'label-danger': notification.notification_class == 'label-danger'
                                          }"
                                    >
                                        {{ notification.notification_type }}
                                    </span>
                                    <span class="notification-txt" v-html="notification.notification_txt"></span>
                                </div>
                                <div class="acknowledge-details" v-if="notification.reviewed_ts">
                                    <div v-if="notification.reviewed_by">
                                        Acknowledged by: {{ notification.reviewed_by.first_nm }} {{ notification.reviewed_by.last_nm }}
                                    </div>
                                    <div>
                                        Acknowledged at: {{ notification.reviewed_ts }}
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    @import '../../sass/_global_variables.scss';

    #notifications-toggle-acknowledged {
        position: absolute;
        bottom: 5px;
        left: 13px;
        background-color: $border-gray;
        border: 1px solid $border-gray;
        border-radius: 2px;

        div {
            float: left;
            width: 40px;
            text-align: center;
            padding: 5px;
            margin: 0;
            font-size: 75%;
            line-height: 1;
            font-weight: bold;
            cursor: default;

            &:not(.raised) {
                color: lighten($dashboard-text-color,15%);
                font-weight: normal;
                cursor: pointer;
            }
        }
    }

    #user-notifications-list {
        max-height: 85px;
        overflow-y: auto;

        .list-group {
            margin-bottom: 0;

            i.close {
                color: $dashboard-red;
            }

            i.close:hover {
                color: darken($dashboard-red,15%);
            }

            .list-group-item {
                border-left: none;
                border-right: none;
                padding: 5px 10px;

                &:first-child {
                    border-top: none;
                }

                &:last-child {
                    border-bottom: none;
                }

                &:hover {
                    background-color: #e8e8e8;
                }

                .notification-txt {
                    font-size: 75%;
                    line-height: 1;
                }
            }

            span.label {
                margin-right: 3px;
            }

            .acknowledge-details {
                padding-left: 25px;

                div {
                    font-size: 75%;
                    line-height: 1;
                    padding: 5px 0;
                    color: lighten($dashboard-text-color, 15%);

                    &:first-child {
                        padding-top: 10px;
                    }
                }
            }
        }
    }

@media (max-width:$break-md) {
    #user-notifications-list {
        max-height: 150px;
    }
}
</style>

<script>
    export default{
        data() {
            return {
                notifications: [],
                showAcknowledged: false,
                loading: true,
                removed: [],
                scrolling: {
                    paused: false,
                    offset: 0,
                    timer: null
                }
            }
        },

        methods: {
            toggleShowAcknowledged: function(show) {
                if (show === this.showAcknowledged) return;

                this.showAcknowledged = !this.showAcknowledged;

                this.getNotifications();
            },

            getNotifications: function(success) {
                this.removed = [];

                var request = this.$http.get('/user/notifications', {
                    params: {
                        showAll: (this.showAcknowledged) ? 1 : 0
                    }
                }).then(function(response) {
                    if (response.data) {
                        this.notifications = response.data
                    }
                    this.loading = false;
                });
            },

            queueGetNotifications() {
                var vm = this;
                setTimeout(function() {
                    vm.getNotifications();
                }, 250);
            },

            removeNotification(notification_id) {
                if (this.removed.indexOf(notification_id) != -1) {
                    return false;
                }
                this.removed.push(notification_id);
                var vm = this;
                var request = this.$http.post('/user/notifications/acknowledge/'+notification_id);
                request.then(function(response) {
                    if (response.data) {
                        if (response.data.notification_id == notification_id) {
                            vm.removeNotificationFromList(notification_id);
                        }
                    }
                });
            },

            removeNotificationFromList(notification_id) {
                var vm = this;
                setTimeout(function() {
                    var notification_ids = vm.notifications.map(function (n) {
                        return n.notification_id;
                    });
                    vm.notifications.splice(notification_ids.indexOf(notification_id),1);
                },250);
            }
        },

        mounted: function() {
            this.queueGetNotifications();
        }
    }
</script>



// WEBPACK FOOTER //
// user-notification-list.vue?22ef38b8